export const REFERRAL_USERS_PROGRESSES_PAGE_LIMIT = 20;
